import React from 'react';
import IOSDownloadSVG from '../assets/AppleStoreBadge.svg';
import AndroidDownloadSVG from '../assets/GooglePlayBadge.svg';

const CTASection = () => {
  return (
    <section className="py-20 bg-gray-300 text-[#333333] text-center">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold mb-4">
          Get Started Today!
        </h2>
        <p className="text-lg text-[#666666] mb-8">
          Download the app now and experience the next level of fun and friendly competition.
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4">
          {/* iOS Store Badge */}
          <button aria-label="Download on iOS">
            <img
              src={IOSDownloadSVG}
              alt="Download on the App Store"
              className="h-12 transition-transform duration-300 hover:scale-105"
            />
          </button>
          {/* Android Store Badge */}
          <button aria-label="Download on Android">
            <img
              src={AndroidDownloadSVG}
              alt="Download on Google Play"
              className="h-12 transition-transform duration-300 hover:scale-105"
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
